import { render } from "./Numpad.vue?vue&type=template&id=36032bee&bindings={\"code\":\"props\",\"letter\":\"props\",\"taskid\":\"props\",\"currentCode\":\"setup\",\"addnum\":\"setup\",\"props\":\"setup\"}"
import script from "./Numpad.vue?vue&type=script&lang=js"
export * from "./Numpad.vue?vue&type=script&lang=js"

import "./Numpad.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script